module.exports = {"id":"dp2_3l3q1","text":"Engaging in Citizenship through Digital Technologies","instructions":"Digital civic participation is best described as:","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_3l3q1-a1","text":"Active involvement in society using digital tools","score":3.7},{"id":"dp2_3l3q1-a2","text":"Occasional online commenting","score":1.3},{"id":"dp2_3l3q1-a3","text":"Consuming political news only","score":1.3}],"category":"2.3"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.3/l3q1.json
// module id = 1032
// module chunks = 41